<script>
  import { createEventDispatcher, onDestroy, onMount } from "svelte"

  const dispatch = createEventDispatcher()
  let element

  function close() {
    dispatch("close")
  }

  function closeOnEscape(event) {
    if (event.key === "Escape") {
      close()
    }
  }

  onMount(() => {
    document.body.classList.add("overflow-hidden")
    element.focus({
      preventScroll: true,
    })
  })

  onDestroy(() => {
    document.body.classList.remove("overflow-hidden")
  })
</script>

<svelte:window on:keydown={closeOnEscape} />

<div
  class="[ fixed z-modal inset-0 overflow-y-auto ]"
  aria-labelledby="modal-title"
  role="dialog"
  aria-modal="true"
  bind:this={element}
  tabindex="0"
>
  <div class="[ flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0 ]">
    <div
      on:click={close}
      class="
        [ fixed inset-0 transition-opacity ]
        [ bg-black bg-opacity-50 ]
      "
      aria-hidden="true"
    />

    <span class="[ hidden sm:inline-block sm:align-middle sm:h-screen ]" aria-hidden="true">&#8203;</span>

    <slot />
  </div>
</div>
